import React from 'react';
import { Skeleton } from '@mui/material';

interface SkeletonBlockProps {
    amount?: number;
    height?: number;
}

export const SkeletonBlock = (props: SkeletonBlockProps) => {
    const { amount = 1, height } = props;
    return (
        <>
            {Array.from({ length: amount }, (_, i) => (
                <Skeleton animation="wave" key={i} height={height} data-testid="skeleton" />
            ))}
        </>
    );
};
